import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { uploadMarkedAttendance } from '../services/api';
import { useLanguage } from '../LanguageContext';

function UploadAttendancePage() {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [showAttendanceMenu, setShowAttendanceMenu] = useState(true);
  const username = localStorage.getItem('username');

  const handleFileChange = (e) => {
    setPhoto(e.target.files[0]);
    setResult(null);
  };

  const handleUpload = async () => {
    if (!photo) {
      alert('Please select a photo or PDF');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('photo', photo);

    try {
      const response = await uploadMarkedAttendance(formData);
      setResult(response.data);
      alert('Attendance processed successfully! ' + response.data.message);
    } catch (error) {
      alert('Failed to process attendance. Please ensure the image is clear with visible QR codes.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={{display: 'flex', minHeight: '100vh'}}>
      <div style={{width: '250px', backgroundColor: '#f8f9fa', borderRight: '1px solid #dee2e6', padding: '20px'}}>
        <div style={{marginBottom: '30px', textAlign: 'center'}}>
          <img src="/misk_logo.png" alt="MISK Logo" style={{height: '60px'}} />
        </div>
        <nav>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            📊 Dashboard
          </div>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            👥 Students
          </div>
          <div style={{marginBottom: '10px'}}>
            <div 
              style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', backgroundColor: showAttendanceMenu ? '#e8f5e9' : 'transparent', color: '#2d5f3f', fontWeight: '500'}}
              onClick={() => setShowAttendanceMenu(!showAttendanceMenu)}
            >
              📋 Attendance {showAttendanceMenu ? '▼' : '▶'}
            </div>
            {showAttendanceMenu && (
              <>
                <div 
                  style={{paddingLeft: '30px', paddingTop: '8px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/attendance-sheet')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Generate Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', backgroundColor: '#e8f5e9', color: '#555', fontWeight: '500'}}
                >
                  Upload Offline Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/online-attendance')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Online Attendance
                </div>
              </>
            )}
          </div>
        </nav>
      </div>

      <div style={{flex: 1}}>
        <div className="container">
          <div className="header">
            <h1 style={{margin: 0}}>Upload Marked Attendance</h1>
            <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
              <select value={language} onChange={(e) => setLanguage(e.target.value)} className="lang-select">
                <option value="en">English</option>
                <option value="ta">தமிழ்</option>
                <option value="ar">العربية</option>
              </select>
              <span>Welcome, {username}</span>
              <button className="btn btn-logout" onClick={handleLogout}>{t('logout')}</button>
            </div>
          </div>

      <div className="card" style={{maxWidth: '800px', margin: '0 auto'}}>
        <h2 style={{marginBottom: '30px'}}>Automatic Attendance Detection</h2>
        
        <div style={{padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', marginBottom: '20px'}}>
          <h4 style={{marginTop: 0}}>How it works:</h4>
          <ol style={{marginBottom: 0, lineHeight: '1.8'}}>
            <li>Print the generated attendance sheet</li>
            <li>Mark attendance physically with checkmarks (✓, X, or fill the checkbox)</li>
            <li>Take a clear photo or scan as PDF</li>
            <li>Upload here - system will automatically detect and save attendance</li>
          </ol>
        </div>

        <div className="form-group">
          <label>Upload Photo or PDF with Marked Attendance *</label>
          <input 
            type="file" 
            accept="image/*,application/pdf"
            onChange={handleFileChange}
          />
          <p style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
            Ensure good lighting and all QR codes are visible
          </p>
        </div>

        <button 
          className="btn btn-primary" 
          onClick={handleUpload}
          disabled={loading || !photo}
          style={{width: '100%', marginTop: '20px'}}
        >
          {loading ? 'Processing...' : 'Upload and Process Attendance'}
        </button>

        {result && (
          <div style={{marginTop: '30px', padding: '20px', backgroundColor: '#e8f5e9', borderRadius: '8px'}}>
            <h3 style={{color: '#2d5f3f', marginTop: 0}}>✓ Processing Complete</h3>
            <p><strong>Message:</strong> {result.message}</p>
            
            {result.detected && result.detected.length > 0 && (
              <div style={{marginTop: '20px'}}>
                <h4>Detected Students:</h4>
                {result.detected.map((student, idx) => (
                  <div key={idx} style={{padding: '10px', backgroundColor: 'white', borderRadius: '5px', marginBottom: '10px'}}>
                    <p><strong>App No:</strong> {student.applicationNumber}</p>
                    <p><strong>Month:</strong> {student.month}</p>
                    <p><strong>Marked Dates:</strong> {student.markedDates?.length || 0} dates detected</p>
                  </div>
                ))}
              </div>
            )}
            
            <button 
              className="btn btn-primary" 
              onClick={() => navigate('/dashboard')}
              style={{marginTop: '20px'}}
            >
              Back to Dashboard
            </button>
          </div>
        )}
      </div>
        </div>
      </div>
    </div>
  );
}

export default UploadAttendancePage;
